import React, { useEffect, useState } from "react";
import { message, Checkbox, Input, Button, Select } from "antd";
import { approveunapproveUser } from "../../../../api/login/Login";
import { useParams } from "react-router-dom";

const { Option } = Select;

function ApprovedArea({ retailerInfo }) {
  const params = useParams();
  const id = params?.id;
  const [checkBoxDisable, setCheckboxDisable] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    is_adhaar_verified: false,
    is_pan_verified: false,
    isIdentity_verified: false,
    is_gst: false,
    is_bank: false,
    is_document: false,
    is_kycVid: false,
    is_personalDetails: false,
    is_self_declare: false,
    remark: "",
    is_approved: "",
  });

  // Handle approval status change
  const handleApprovalChange = (value) => {
    if (value === true) {
      // If approval is set to true, set all verification fields to true
      setCheckboxDisable(true);
      setFormData((prev) => ({
        ...prev,
        is_approved: true,
        is_adhaar_verified: true,
        is_pan_verified: true,
        isIdentity_verified: true,
        is_gst: true,
        is_bank: true,
        is_document: true,
        is_kycVid: true,
        is_personalDetails: true,
        is_self_declare: true,
        remark: "",
      }));
    } else if (value === "pending") {
      // Pending / Needs correction mode
      setCheckboxDisable(false);
      setFormData((prev) => ({
        ...prev,
        is_approved: "pending",
        remark: prev.remark || "",
      }));
    } else {
      // Not approved / rejected mode
      setCheckboxDisable(false);
      setFormData((prev) => ({
        ...prev,
        is_approved: false,
        remark: prev.remark || "",
      }));
    }
  };

  // Handle checkbox change
  const handleCheckboxChange = (key) => {
    setFormData((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // Handle remark change
  const handleRemarkChange = (e) => {
    setFormData({ ...formData, remark: e.target.value });
  };

  // Submit handler
  const handleSubmit = async (action) => {
    try {
      setIsSubmitting(true);
      const isApprove = action === "approve";
      const payload = {
        ...formData,
        action: action,
        is_approved: isApprove,
      };

      const res = await approveunapproveUser(payload, id);
      console.log("Approval response:", res);

      if (res?.error === false || res?.statusCode == "200" || res?.status === 200) {
        message.success(res.message || `${action.toUpperCase()} action completed successfully!`);
        if (isApprove) {
          setCheckboxDisable(true);
          setFormData((prev) => ({
            ...prev,
            is_approved: true,
            is_adhaar_verified: true,
            is_pan_verified: true,
            isIdentity_verified: true,
            is_gst: true,
            is_bank: true,
            is_document: true,
            is_kycVid: true,
            is_personalDetails: true,
            is_self_declare: true,
            remark: "",
          }));
        } else {
          setCheckboxDisable(false);
          setFormData((prev) => ({
            ...prev,
            is_approved: action === "pending" ? "pending" : false,
          }));
        }
      } else {
        message.error(res?.message || `${action} action failed.`);
      }
    } catch (error) {
      console.error("Submission error:", error);
      message.error(error?.response?.data?.message || "An error occurred during submission.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Validation
  const allChecked =
    formData.is_adhaar_verified === true &&
    formData.is_pan_verified === true &&
    formData.isIdentity_verified === true &&
    formData.is_gst === true &&
    formData.is_bank === true &&
    formData.is_document === true &&
    formData.is_kycVid === true &&
    formData.is_personalDetails === true &&
    formData.is_self_declare === true;

  const atLeastOneUnchecked =
    formData.is_adhaar_verified === false ||
    formData.is_pan_verified === false ||
    formData.isIdentity_verified === false ||
    formData.is_gst === false ||
    formData.is_bank === false ||
    formData.is_document === false ||
    formData.is_kycVid === false ||
    formData.is_personalDetails === false ||
    formData.is_self_declare === false;

  const hasRemark = formData.remark.trim().length > 0;

  const isApproveButtonEnabled =
    (formData.is_approved === true || allChecked) && !isSubmitting;
  const isPendingButtonEnabled =
    formData.is_approved !== true && atLeastOneUnchecked && hasRemark && !isSubmitting;
  const isUnapproveButtonEnabled =
    formData.is_approved === false && hasRemark && !isSubmitting;

  useEffect(() => {
    if (retailerInfo?.is_approved === true) {
      setCheckboxDisable(true);
    }
    setFormData((prev) => ({
      ...prev,
      is_adhaar_verified: !!retailerInfo?.is_adhaar_verified,
      is_pan_verified: !!retailerInfo?.is_pan_verified,
      isIdentity_verified: !!retailerInfo?.isIdentity_verified,
      is_gst: retailerInfo?.is_gst !== undefined ? !!retailerInfo?.is_gst : false,
      is_bank: !!retailerInfo?.is_bank,
      is_document: !!retailerInfo?.is_document,
      is_kycVid: !!retailerInfo?.is_kycVid,
      is_personalDetails: !!retailerInfo?.is_personalDetails,
      is_self_declare: !!retailerInfo?.is_self_declare,
      remark: retailerInfo?.remark || "",
      is_approved: retailerInfo?.is_approved,
    }));
  }, [retailerInfo]);

  return (
    <div className="approved-area p-4">
      <h3 className="mb-3">Approval & Verification Status</h3>
      <Select
        style={{ width: "100%", marginBottom: "1.5rem" }}
        onChange={handleApprovalChange}
        value={
          formData?.is_approved === true
            ? true
            : formData?.is_approved === "pending"
            ? "pending"
            : formData?.is_approved === false
            ? false
            : ""
        }
      >
        <Option disabled value="">
          Select Approval Status
        </Option>
        <Option value={true}>Approved</Option>
        <Option value="pending">Pending / Needs Correction</Option>
        <Option value={false}>Not Approved / Rejected</Option>
      </Select>

      <div className="p-3 border rounded bg-light mb-3">
        <h6 className="fw-bold mb-3 text-secondary">
          Verification Checkpoints (Untick any section that needs re-fill/re-upload):
        </h6>
        <div className="row g-3">
          <div className="col-md-4">
            <Checkbox
              checked={formData.is_adhaar_verified}
              onChange={() => handleCheckboxChange("is_adhaar_verified")}
              disabled={checkBoxDisable}
            >
              Aadhaar Verified
            </Checkbox>
          </div>
          <div className="col-md-4">
            <Checkbox
              checked={formData.is_pan_verified}
              onChange={() => handleCheckboxChange("is_pan_verified")}
              disabled={checkBoxDisable}
            >
              PAN Verified
            </Checkbox>
          </div>
          <div className="col-md-4">
            <Checkbox
              checked={formData.isIdentity_verified}
              onChange={() => handleCheckboxChange("isIdentity_verified")}
              disabled={checkBoxDisable}
            >
              Identity Verified
            </Checkbox>
          </div>
          <div className="col-md-4">
            <Checkbox
              checked={formData.is_personalDetails}
              onChange={() => handleCheckboxChange("is_personalDetails")}
              disabled={checkBoxDisable}
            >
              Personal Details Verified
            </Checkbox>
          </div>
          <div className="col-md-4">
            <Checkbox
              checked={formData.is_gst}
              onChange={() => handleCheckboxChange("is_gst")}
              disabled={checkBoxDisable}
            >
              GST & Business Details Verified
            </Checkbox>
          </div>
          <div className="col-md-4">
            <Checkbox
              checked={formData.is_bank}
              onChange={() => handleCheckboxChange("is_bank")}
              disabled={checkBoxDisable}
            >
              Bank Details Verified
            </Checkbox>
          </div>
          <div className="col-md-4">
            <Checkbox
              checked={formData.is_document}
              onChange={() => handleCheckboxChange("is_document")}
              disabled={checkBoxDisable}
            >
              KYC Documents Verified
            </Checkbox>
          </div>
          <div className="col-md-4">
            <Checkbox
              checked={formData.is_kycVid}
              onChange={() => handleCheckboxChange("is_kycVid")}
              disabled={checkBoxDisable}
            >
              KYC Video Verified
            </Checkbox>
          </div>
          <div className="col-md-4">
            <Checkbox
              checked={formData.is_self_declare}
              onChange={() => handleCheckboxChange("is_self_declare")}
              disabled={checkBoxDisable}
            >
              Self Declaration Accepted
            </Checkbox>
          </div>
        </div>
      </div>

      {formData.is_approved !== true && (
        <div className="mb-3">
          <label className="form-label fw-bold">
            Staff Remark / Reason <span className="text-danger">*</span> (Sent to retailer):
          </label>
          <Input.TextArea
            rows={3}
            placeholder="Enter specific instructions (e.g., Bank passbook photo is blurry, please re-upload clear statement or cancelled cheque)"
            value={formData.remark}
            onChange={handleRemarkChange}
          />
        </div>
      )}

      <div className="d-flex flex-wrap gap-2 mt-4">
        <Button
          type="primary"
          onClick={() => handleSubmit("approve")}
          disabled={!isApproveButtonEnabled}
          style={{ backgroundColor: isApproveButtonEnabled ? "#16a34a" : undefined, borderColor: isApproveButtonEnabled ? "#16a34a" : undefined }}
        >
          Approve Member
        </Button>

        <Button
          onClick={() => handleSubmit("pending")}
          disabled={!isPendingButtonEnabled}
          style={{
            backgroundColor: isPendingButtonEnabled ? "#f59e0b" : undefined,
            color: isPendingButtonEnabled ? "#ffffff" : undefined,
            borderColor: isPendingButtonEnabled ? "#f59e0b" : undefined,
          }}
        >
          Mark Pending / Request Correction
        </Button>

        <Button
          danger
          onClick={() => handleSubmit("unapprove")}
          disabled={!isUnapproveButtonEnabled}
        >
          Reject / Unapprove
        </Button>
      </div>
    </div>
  );
}

export default ApprovedArea;
